import type { CasinoPlayerGames, CasinoServiceParameters } from '@ps/web-martech-cms-types';
import type { ValuesType } from 'utility-types';

import type { MarketingTag } from '@swf/core/types/CasinoGame';
import type { WidgetReference } from '@swf/core/types/Widget';

export interface CasinoWidget extends WidgetReference {
  game_service?: string;
  params?: CasinoServiceParameters;
  hide_on_login?: boolean;
  logged_in_only?: boolean;
}

export type CasinoIcon = NonNullable<ValuesType<CasinoServiceParameters['ims']['icon_tags']>>;
export type MosaicLayout = CasinoPlayerGames['mosaic_layout'];
export type IncludeTags = string[];

export enum RenderNames {
  minBet = 'minBet',
  maxBet = 'maxBet',
  returnToPlayer = 'returnToPlayer',
  paylines = 'paylines',
  features = 'features'
}

export type ProviderLogos =
  | '1x2 Gaming'
  | '4ThePlayer'
  | '7 Deuce Gaming'
  | 'AGS'
  | 'amusnet'
  | 'BTG'
  | 'Blueprint'
  | 'Bragg'
  | 'CapeCod'
  | 'Cape Cod'
  | 'Card and Table'
  | 'Cayetano'
  | 'Core Gaming'
  | 'DGC'
  | 'DWG'
  | 'EGT'
  | 'ELK'
  | 'Everi'
  | 'Evolution'
  | 'Fantasma'
  | 'Games Global'
  | 'Gamevy'
  | 'Gaming Corps'
  | 'Gaming Realms'
  | 'GiocaOnline'
  | 'Greentube'
  | 'Hacksaw Gaming'
  | 'High5'
  | 'IGT'
  | 'Ingenuity'
  | 'Ino'
  | 'Inspired'
  | 'Instant Win Gaming'
  | 'Kalamba'
  | 'Konami'
  | 'Leander'
  | 'Light And Wonder'
  | 'Lightning Box'
  | 'MGA'
  | 'NetEnt'
  | 'Nolimit City'
  | 'ODDSworks'
  | 'Octoplay'
  | 'OnAir'
  | 'Onseo'
  | 'PYRSoftware'
  | 'PlayNGo'
  | 'Playson'
  | 'Playtech'
  | 'Playzido'
  | 'Pragmatic'
  | 'Premium'
  | 'Push'
  | 'Push Gaming'
  | 'Quickspin'
  | 'RAW Gaming'
  | 'RTG'
  | 'Red Rake'
  | 'Red Tiger'
  | 'Reel Play'
  | 'Relax Gaming'
  | 'RubyPlay'
  | 'SG Digital'
  | 'Skywind'
  | 'Spinomenal'
  | 'Spribe'
  | 'Stakelogic'
  | 'Synot'
  | 'Thunderkick'
  | 'Video Poker'
  | 'WHS'
  | 'WMG'
  | 'Wazdan'
  | 'Yggdrasil'
  | 'authenticgaming'
  | 'flutterstudios'
  | 'gol_games'
  | 'iSoftBet'
  | 'subtract'
  | 'union'
  | 'Endorphina';

export type FeatureVariant = 'standard' | 'no-bottom' | 'mini-detail' | 'persistent-info';

export type MarketingIconType = MarketingTag.New | MarketingTag.Exclusive;

export type CasinoGameService =
  | 'casino.games.all.stream'
  | 'casino.games.recent.stream'
  | 'casino.games.recommended.stream'
  | 'casino.games.myfsb'
  | 'casino.games.playergames'
  | 'casino.live.games.stream'
  | '/api/v1-preview/casino/games/rapid/stream';

export enum CasinoSection {
  OneBigSquare = '1 big square',
  FourSquares = '4 squares',
  OneTopTwoBottom = '1 top 2 bottom',
  TwoTopOneBottom = '2 top 1 bottom',
  OneTopOneBottom = '1 top 1 bottom'
}

export * from './error';
export * from './gameCards';
export * from './races';
